var _rect, _path, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeHold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 40,
    viewBox: "0 0 148 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 40,
    rx: 20,
    fill: "#CED4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20V20.5C39.9375 21.125 39.875 21.75 39.75 22.375C39.25 24.5 38.0625 26.3125 36.4375 27.6875C36.375 27.75 36.25 27.8125 36.1875 27.875C35.625 28.3125 35 28.6875 34.3125 29C34.1875 29.0625 34.0625 29.125 33.9375 29.1875C33.6875 29.3125 33.4375 29.375 33.1875 29.4375C32.875 29.5625 32.5625 29.625 32.25 29.6875C31.5 29.9375 30.75 30 30 30C24.5 30 20 25.5 20 20C20 14.5 24.5 10 30 10C35.5 10 40 14.5 40 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 20.5005C39.9372 21.1255 39.8747 21.7505 39.7497 22.3755C39.2497 24.5005 38.0622 26.313 36.4372 27.688C36.3747 27.7505 36.2497 27.813 36.1872 27.8755C35.6247 28.313 34.9997 28.688 34.3122 29.0005C34.1872 29.063 34.0622 29.1255 33.9372 29.188C33.6872 29.313 33.4372 29.3755 33.1872 29.438C33.1872 29.438 27.7497 24.0005 27.6872 23.938L24.4997 20.313C24.1247 19.8755 24.1247 19.188 24.6247 18.7505C25.0622 18.3755 25.7497 18.3755 26.1872 18.8755C26.2497 18.938 28.6872 21.3755 28.7497 21.438L33.8747 15.938C34.3122 15.5005 34.9997 15.5005 35.4372 15.8755C35.4372 15.938 39.9997 20.5005 39.9997 20.5005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4997 24.3745C28.1872 24.3745 27.8747 24.2495 27.6872 23.9995L24.4997 20.3745C24.1247 19.937 24.1247 19.2495 24.6247 18.812C25.0622 18.437 25.7497 18.437 26.1872 18.937L28.5622 21.687L33.8747 15.9995C34.3122 15.562 34.9997 15.562 35.4372 15.937C35.8747 16.3745 35.8747 17.062 35.4997 17.4995L29.3747 24.062C29.0622 24.2495 28.8122 24.3745 28.4997 24.3745Z",
    fill: "#3C2212"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 25,
    fill: "#3C2212",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: 600
  }, "\n    Holding\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeHold);
export default __webpack_public_path__ + "static/media/badge-hold.166ee5180f803a613ae55237c72966f4.svg";
export { ForwardRef as ReactComponent };